export default {
  administration: {
    //spółki
    companyAdd: 'Dodawanie nowej spółki',
    companyEdit: 'Edycja spółki nr sys.',
    companyNew: 'Nowa spółka',
    noCompanies: 'Brak spółek w systemie',
    basicData: 'Dane podstawowe',
    visualData: 'Dane wizualne',
    sensitiveData: 'Dane wrażliwe',
    sensitiveDataWarning:
      'Uwaga! Zmiana tych danych natychmiast wpływa na działanie systemu. Dokonuj modyfikacji tylko wtedy, gdy masz pewność, jaki będzie ich wpływ na system POK.',
    logo: 'Logo',
    stamp: 'Pieczątka',
    personalLanguage: 'Nazewnictwo',
    language: 'Język',
    color: 'Kolor',
    invoiceTemplate: 'Szablon faktur',
    noFull: 'Liczba porządkowa',
    emailInvoice: 'E-mail na faktury',
    footer: 'Stopka',
    footerEn: 'Stopka w j. angielskim',
    uploadGraphicFile: 'Wgraj plik graficzny',
    showMargin: 'Pokaż marżę',
    eod: 'Komunikuje się z EOD',
    ksef: 'Obsługuje KSeF',
    symphonyHandel: 'Eksportuje FVS do Symfonii Handel',

    //pracownicy
    synchrWithOneTool: 'Synchronizuj z OneTool',
    all: 'Wszyscy',
    inactive: 'Nieaktywni z uprawnieniami',
    deletePermissions: 'Usuń uprawnienia',
    deleteUserPermissions: 'Usuń uprawnienia użytkownika',
    askDeleteUserPermissions:
      'Czy na pewno usunąć wszystkie uprawnienia przypisane do tego użytkownika?',
    askDeletePermissions:
      'Czy na pewno chcesz usunąć wszystkie uprawnienia wszystkich nieaktywnych użytkowników?',
    position: 'Stanowisko',
    oneToolId: 'OneTool ID',
    nameSurname: 'Imię i nazwisko',
    login: 'Login',
    email: 'E-mail',
    supervisor: 'Przełożony',
    manager: 'Szef',
    technical: 'Techniczny',
    noEmployees: 'Brak pracowników w systemie',
    signAdd: 'Dodawanie nowego podpisu do pracownika: {{employeeName}}',
    signEdit: 'Edycja podpisu pracownika: {{employeeName}}',
    employeeSign: 'Podpis',
    askDeleteSignEmployee: 'Czy na pewno usunąć podpis?',

    //zespoły
    teamNew: 'Nowy zespół',
    teamEdit: 'Edycja zespołu nr sys.',
    teamAdd: 'Dodawanie nowego zespołu',
    managerName: 'Szef zespołu',
    noTeams: 'Brak zespołów w systemie',
    paeSupport: 'Obsługuje PAE',
    tvSupport: 'Obsługuje TV',
    oneToolTeam: 'Zespół OneTool',
    oneToolTeams: 'Zespoły OneTool',
    noOneToolTeams: 'Brak zespołów z OneTool',
    pathPhase: 'Faza',
    pathPhaseTooltip:
      'Faza przypisana do tego zespołu. Zespół z przypisaną fazą jest „<strong>zespołem fazowym</strong>" - dzięki temu system potrafi sam rozpoznać, który zespół opiekuje się pozycją w danej fazie, bez pytania użytkownika. Pole zostaw puste dla zespołów spoza modelu fazowego.',
    pathPhaseCompanyTooltip:
      'Włącza w tej spółce mechanizm faz. Gdy <strong>włączony</strong> - przy zakładaniu kampanii w tej spółce można wskazać, które fazy jej dotyczą, a pozycje i zamówienia można oznaczać fazą. Gdy <strong>wyłączony</strong> - w tej spółce faz nie ma w ogóle. Sam przełącznik <strong>nie</strong> wymusza podania fazy.',

    //profile mediaplanów
    estimateProfiles: 'Profile mediaplanów',
    estimateProfileNew: 'Nowy profil',
    estimateProfileAdd: 'Dodawanie nowego profilu',
    estimateProfileEdit: 'Edycja profilu',
    noEstimateProfiles: 'Brak profili mediaplanów w systemie',
    commissions: 'Prowizje',
    technicalCost: 'Koszt techniczny',
    relatedTeams: 'Zespoły powiązane',
    tv: 'TV',
    tvBuying: 'TV zakup',
    autoSalesBlockDisabled: 'Wyłączona auto blokada sprzedaży',
    absence: 'Brak',
    visible: 'Widoczne',
    obligatory: 'Obowiązkowe',

    //kategorie profili
    profileCategory: 'Kategoria profilu',
    profileCategories: 'Kategorie profili',
    profileCategoryAdd: 'Dodawanie nowej kategorii profilu',
    profileCategoryNew: 'Nowa kategoria profilu',
    profileCategoryEdit: 'Edycja kategorii profilu',
    noProfileCategories: 'Brak kategorii profili w systemie.',
    salesFinancialAccount: 'Konto księgowe sprzedaży',
    purchasesFinancialAccount: 'Konto księgowe zakupu',
    commissionsFinancialAccount: 'Konto księgowe prowizji',
    profileCategoryAccountsInternal: 'Kontrahent należy do Group One',
    profileCategoryYearAdd: 'Dodawanie nowych kont do kategorii profilu',
    profileCategoryYearNew: 'Nowe konta do kategorii profilu',
    profileCategoryYearEdit: 'Edycja kont kategorii profilu',
    profileCategoryYearDelete: 'Usuwanie kont z kategorii profilu',
    askProfileCategoryYearDelete: 'Czy usunąć konta kategorii profilu',
    noProfileCategoryYears: 'Brak kont dla kategorii profilu.',
    profile: 'Profil',

    //Pola profili
    sales: 'Sprzedaż',
    rcSalesTotal: 'RC sprzedaż total',
    salesSurchargePercent: '% Dopłata sprzedaż',
    salesDiscountPercent: '% Rabat sprzedaż',
    salesNet: 'Netto sprzedaż',
    salesCommissionPercent: '% Prowizja sprzedaż',
    salesCommissionAmount: 'Prowizja sprzedaż kwota',
    salesNetTechnicalCost: 'Netto sprzedaż koszt techniczny',
    salesBeerTax: 'Netto sprzedaż podatek piwny',
    salesPrintingCosts: 'Netto sprzedaż koszty druku',
    salesOperatingFee: 'Netto sprzedaż opłata operacyjna',
    salesBlockSurcharge: 'Netto sprzedaż dopłata za blok',
    salesTransferCosts: 'Netto sprzedaż koszty transferu',
    salesNetTotal: 'Netto sprzedaż total',

    buy: 'Zakup',
    rcPurchase: 'RC zakup',
    purchaseSurchargePercent: '% Dopłata zakup',
    purchaseDiscountPercent: '% Rabat zakup',
    purchaseNet: 'Netto zakup',
    purchaseTechnicalCost: 'Netto zakup koszt techniczny',
    purchaseBeerTax: 'Netto zakup podatek piwny',
    purchasePrintingCosts: 'Netto zakup koszty druku',
    purchaseOperatingFee: 'Netto zakup opłata operacyjna',
    purchaseBlockSurcharge: 'Netto zakup dopłata za blok',
    purchaseTransferCosts: 'Netto zakup koszty transferu',
    purchaseNetTotal: 'Netto zakup total',

    media: 'Media',
    numberOfMedia: 'Liczba nośników',
    technologyDictionary: 'Technologia (słownik)',
    regionDictionary: 'Rejon (słownik)',
    additionalDescription: 'Dodatkowy opis',

    format: 'Format',
    formatRadio: 'Format (radio)',
    formatPress: 'Format (prasa)',
    formatInternet: 'Format (internet)',

    category: 'Kategoria',
    categoryInternet: 'Kategoria (internet)',
    categoryLabcon: 'Kategoria (Labcon)',

    purchaseForm: 'Forma zakupu',
    purchaseFormInternet: 'Forma zakupu (internet)',
    purchaseMethod: 'Sposób zakupu (TV)',

    emissionType: 'Typ emisji',
    emissionTypeRadio: 'Typ emisji (radio)',
    emissionTypeCinema: 'Typ emisji (kino)',

    service: 'Usługa',
    action: 'Działanie',
    actionGroup: 'Grupa działań',
    serviceExternalWorkPercent: '% Prace zewnętrzne',
    serviceCreationPercent: '% Kreacja',
    serviceChangeProductionPercent: '% Produkcja Change',
    serviceStrategyPercent: '% Strategia',
    serviceProductionBroadcastPercent: '% Produkcja broadcast',
    serviceClientServicePercent: '% Client service',

    additionalInformation: 'Inne',
    isUpSell: 'Czy upsell',
    netCustomerAccount: 'Netto konto klienta',
    copySize: 'Długość kopii',
    orderNumber: 'Numer zlecenia',
    medium: 'Medium (zagraniczne)',
    ownName: 'Nazwa własna',
    labconChannel: 'Kanał Labcon',

    qualifiedMedium: 'Medium kwalifikowane',

    //konfiguracja maili
    mailConfig: 'Konfiguracja maili',
    mailConfigAdd: 'Dodawanie nowej konfiguracji',
    mailConfigNew: 'Nowa konfiguracja',
    mailConfigEdit: 'Edycja konfiguracji o nr sys.',
    noMailConfigs: 'Brak konfiguracji maili w systemie.',
    type: 'Typ',
    emails: 'Adresy e-mail',
    mailConfigType: 'Typ konfiguracji',

    //konfiguracja zadań
    jobConfig: 'Konfiguracja zadań cyklicznych',
    jobConfigAdd: 'Dodawanie nowej konfiguracji',
    jobConfigNew: 'Nowa konfiguracja',
    jobConfigEdit: 'Edycja konfiguracji o nr sys.',
    noJobConfigs: 'Brak konfiguracji zadań w systemie.',
    jobConfigType: 'Typ konfiguracji',
    cron: 'Częstotliwość',
    cronDescription: 'Opis częstotliwości',
    nextStart: 'Następne uruchomienie',
    jobConfigSynchronize: 'Synchronizuj wszystkie zadania',
    cronError: 'Wystąpił błąd przy generowaniu częstotliwości:',

    //konta bankowe
    bankAccounts: 'Konta bankowe',
    bankAccountNew: 'Nowe konto bankowe',
    bankAccountAdd: 'Dodawanie nowego konta bankowego',
    bankAccountEdit: 'Edycja konta bankowego',
    noBankAccounts: 'Brak rachunków bankowych w systemie.',
    bankName: 'Nazwa banku',
    accountNumber: 'Numer konta bankowego',
    swift: 'Swift BIC',
    swiftLong: 'Swift Bank Identity Code',
    invoiceType: 'Typ faktury',
    VATAccountNumber: 'VAT - Nr konta bankowego',
    VATBankName: 'VAT - Nazwa banku',

    //kalendarz
    calendarWorkingDay: 'Kalendarz dni roboczych',
    createYear: 'Utwórz rok',
    askAdd: 'Czy na pewno dodać dzień',
    askDelete: 'Czy na pewno usunąć dzień',
    to: 'do kalendarza dni roboczych?',
    from: 'z kalendarza dni roboczych?',
    addCalendar: 'Dodawanie dnia roboczego',
    deleteCalendar: 'Usuwanie dnia roboczego',
    askAddYear: 'Czy na pewno chcesz utworzyć rok',
    askDeleteYear: 'Czy na pewno chcesz usunąć rok',
    inSystem: 'w systemie?',
    warning:
      'Uwaga, jeżeli rok jest już utworzony, to zostanie usunięty i utworzony ponownie.',

    //slowniki
    dictionaries: 'Słowniki systemowe',
    dictionarySelectedDelete: 'Usunięcie zaznaczonej wartości',
    dictionarySelectedEdit: 'Edycja zaznaczonej wartości',
    dictionarySelectedAdd: 'Dodanie elementu pod zaznaczoną wartością',
    dictionaryDelete: 'Usuwanie ze słownika',
    dictionaryAskDelete: 'Czy na pewno usunąć wartość:',
    dictionaryEdit: 'Edycja słownika ',
    dictionaryAdd: 'Dodawanie wartości do słownika ',
    value: 'Wartość',
    valueEN: 'Wartość w j. angielskim',
    symbol: 'Symbol',

    errorAttachments: 'Błąd przy pobieraniu załączników.',

    //upoważnieni
    authorizedNew: 'Nowy upoważniony',
    authorizedEdit: 'Edycja upoważnionego nr sys.',
    authorizedAdd: 'Dodawanie nowego upoważnionego',
    noAuthorized: 'Brak upoważnionych w systemie',

    //parametry systemu
    parameters: 'Parametry systemu',
    group: 'Grupa',
    editable: 'Edytowalny',
    noParameters: 'Brak parametrów w systemie',
    parameterEdit: 'Edycja parametru',
  },
  tooltips: {
    tooltips: 'Tooltipy',
    tooltipEdit: 'Edycja tooltipa',
    tooltipKey: 'Klucz',
    tooltipDescription: 'Opis pola (gdzie używany)',
    tooltipPlText: 'Treść PL',
    tooltipEnText: 'Treść EN',
    noTooltips: 'Brak tooltipów w systemie',
  },
  umpImport: {
    positionNameUmp: 'Nazwa pozycji (UMP)',
    positionNamePok: 'Nazwa pozycji (POK)',
    positionType: 'Typ pozycji (POK)',
    purchaseSameAsSales: 'Cena zakup = Cena sprzedaż',
    purchaserUmp: 'Zamawiający (UMP)',
    purchaserPok: 'Zamawiający (POK)',
    totalNetBudget: 'Budżet całkowity netto',
    noPositions: 'Brak pozycji do wyświetlenia',
    umpImport: 'Importuj z UMP',
    umpImportDetails: 'Importuj z UMP (profil:',

    umpImportSuccess: 'Import zakończony pomyślnie.',
    umpImportResult:
      'Zaimportowano {{ok}} z {{total}} pozycji (błędnych: {{error}})',
    umpImportSummary: 'Podsumowanie importu',
    unknownPurchaser: 'BRAK ZAMAWIAJĄCEGO!',
    chooseParam: 'Wybór parametru',
    changeParam: 'Zmień parametr',
  },
  recommendedPublisher: {
    recommendedPublishers: 'Rekomendowani dostawcy',
    recommendedPublisherNew: 'Nowa rekomendacja',
    noRecommendedPublishers: 'Brak rekomendowanych dostawców w systemie.',
    purchaser: 'Zamawiający',
    publisherCount: 'Liczba dostawców',
    availablePublishers: 'Dostępni dostawcy',
    scope: 'Zakres',
    editRecommendations: 'Edytuj listę rekomendowanych dostawców',
    publisherName: 'Nazwa dostawcy',
    inherited: 'Odziedziczony',
    inherited2: 'Odziedziczono',
    noAvailablePublishers: 'Brak dostępnych dostawców dla tego profilu',
    summary: 'Razem',
    instruction: 'Rekomendacje się SUMUJĄ:',
    instructionPurchaser: 'Dla zamawiającego: ',
    instructionPurchaserDetails: 'Globalny dla profilu + Spółka + Zamawiający',
    instructionCompany: 'Dla spółki: ',
    instructionCompanyDetails: 'Globalny dla profilu + Spółka',
    instructionGlobal: 'Ogólne: ',
    instructionGlobalDetails: 'Tylko globalny',
    clickToSelectDeselect: '(Kliknij aby zaznaczyć/odznaczyć)',
    recommendedPublishersFileName: 'Rekomendowani_dostawcy',
    exportFullList: 'Eksport pełnej listy rekomendowanych dostawców',
  },
  survey: {
    surveys: 'Ankiety',
    myDraftSurveys: 'Moje robocze',
    mySurveys: 'Moje',
    activeSurveys: 'Uruchomione',
    surveyNew: 'Nowa ankieta',
    surveyAdd: 'Dodawanie nowej ankiety',
    surveyEdit: 'Edycja ankiety',
    noSurveys: 'Brak ankiet w systemie',
    frequency: 'Częstotliwość',
    contractorType: 'Typ kontrahenta',
    validityPeriodDays: 'Okres ważności (dni)',
    validityPeriodDaysTooltip:
      'Liczba dni, przez którą ankieta jest ważna od momentu wysłania. Po upływie tego okresu ankieta traci ważność.',
    remind: 'Ponowne wysyłanie ankiety po utracie ważności pierwszego e-maila',
    remindShort: 'Ponowienie',
    responsiblePersons: 'Osoby odpowiedzialne',
    startDate: 'Data rozpoczęcia',
    startDateTooltip:
      'Data, od kiedy ankieta jest wysyłana do klientów. Jeśli data jest w przyszłości, to ankieta nie jest jeszcze uruchomiona. Po osiągnięciu tej daty ankieta staje się uruchomiona i nie można jej edytować (poza zmianą daty zakończenia lub dezaktywacją ankiety).',
    endDate: 'Data zakończenia',
    question: 'Pytanie',
    questionEn: 'Pytanie w j. angielskim',
    questions: 'Pytania',
    noQuestions: 'Brak pytań',
    responseType: 'Typ odpowiedzi',
    optional: 'Opcjonalne',
    requiredShort: 'Wymagane',
    answer: 'Odpowiedź',
    expectedYesNoAnswer: 'Oczekiwana odpowiedź Tak/Nie',
    warningLight: 'Światło ostrzegawcze',
    unwrittenUppercase: 'NIEZAPISANE',
    saveAndContinue: 'Zapisz i przejdź dalej',
    confirmStartSurveyMessage:
      'Data początku wskazuje, że ankieta zacznie już obowiązywać. W związku z tym po zapisaniu nie będzie możliwa dalsza edycja ankiety. Czy na pewno chcesz kontynuować?',
    confirmEndSurveyMessage:
      'Data zakończenia wskazuje, że ankieta zacznie już obowiązywać. W związku z tym po zapisaniu nie będzie możliwa dalsza edycja ankiety. Czy na pewno chcesz kontynuować?',
    surveyWillBeSentFromDate:
      'Ankieta będzie rozsyłana do klientów od dnia {{date}}. Jeśli nie jest jeszcze gotowa, to usuń datę rozpoczęcia ankiety.',
    questionAdd: 'Dodaj pytanie',
    questionEdit: 'Edycja pytania',
    blockOnWrongAnswer:
      'Blokuj możliwość kontynuacji ankiety przy braku oczekiwanej odpowiedzi',
    blockOnWrongAnswerShort: 'Blokada kontynuacji',
    expectedAnswer: 'Oczekiwana odpowiedź',
    preview: 'Podgląd ankiety',
    moveQuestionUp: 'Przesuń pytanie do góry',
    moveQuestionDown: 'Przesuń pytanie w dół',
    questionDelete: 'Usuń pytanie',
    questionDeleteConfirm: 'Czy na pewno usunąć pytanie?',
    duplicateQuestion: 'W ankiecie występują powtarzające się pytania',
    surveyLocked: 'Ankieta zablokowana - uruchomiona',
    surveyLockedInfo:
      'Ankieta po starcie obowiązywania nie podlega edycji. Możliwa jest tylko zmiana daty zakończenia.',
    surveyActive: 'W trakcie',
    surveyEnded: 'Zakończona',
    surveyScheduled: 'Zaplanowana',
    survey: 'Ankieta',
    emailTo: 'E-mail odbiorcy',
    sendError: 'Błąd wysyłki e-maila',
    badAnswer: 'Niezgodna odpowiedź',
    warningLightShort: 'Ostrzeżenie',
    problem: 'Odpowiedź inna niż oczekiwana',
    answerYesNo: 'Odpowiedź Tak/Nie',
    answerText: 'Odpowiedź Tekst',
    surveyEn: 'Ankieta w j. angielskim',
    emailData: 'Dane do e-maila',
    emailSubject: 'Temat wiadomości',
    emailTemplate: 'Treść wiadomości',
    emailSubjectEn: 'Temat wiadomości w j. angielskim',
    emailTemplateEn: 'Treść wiadomości w j. angielskim',
    emailTemplatePlaceholdersDesc:
      'Wpisz poniższe znaczniki w treści wiadomości — zostaną automatycznie zastąpione właściwymi wartościami.',
    emailTemplatePlaceholdersNote:
      'Uwaga: Szablon musi zawierać wymagane znaczniki czyli: {{required}}, reszta jest opcjonalna.',
    emailTemplatePlaceholderUrl: 'link do ankiety',
    emailTemplatePlaceholderClickToCopy: 'Kliknij aby skopiować',
    surveyResults: 'Zestawienie wyników ankiet',
    surveyResultsFile: 'WynikiAnkiet',
    surveyResultsWithRemarksFile: 'WynikiAnkietZUwagami',
    surveyRequired: 'Wybierz ankietę',
    emailTemplatePlaceholderResponsible:
      'imiona i nazwiska osób odpowiedzialnych',
    emailTemplatePlaceholderCompany: 'nazwa spółki np. Value Media',
    emailTemplatePlaceholderCompanyLong:
      'pełna nazwa spółki np. Value Media Sp. z o.o.',
    nameForClientsTooltip: 'Nazwa ankiety widoczna dla klienta',
    contractorTypeTooltip1:
      'Dostawca lub Zamawiający - ankiety zostaną wysłane do kontrahentów z dowiązaną co najmniej jedną pozycją lub zamawiającym ze spółek wskazanych w ankiecie.',
    contractorTypeTooltip2:
      'Wszyscy - ankiety zostaną wysłane do wszystkich kontrahentów i wszystkich spółek wskazanych w ankiecie, niezależnie od tego, czy w danej spółce istnieje zamawiający lub pozycja powiązana z kontrahentem.',
    contractorTypeTooltip3:
      'Grupy klientów - po wybraniu odpowiedniej grupy klientów ankiety zostaną wysłane do wszystkich kontrahentów znajdujących się w wybranej grupie i wszystkich spółek wskazanych w ankiecie, niezależnie od tego, czy w danej spółce istnieje zamawiający lub pozycja powiązana z kontrahentem.',
    emailTemplatePreview: 'Podgląd szablonu e-mail',
    polishVersion: 'Wersja polska',
    englishVersion: 'Wersja angielska',
    subject: 'Temat',
    emailBody: 'Treść',
    contactType: 'Typ kontaktu',
    sendToGeneral: 'Wysyłaj na Ogólny, gdy nie ma kontaktu wybranego typu',
    clientGroup: 'Grupa kontrahentów',
  },
  clientSurvey: {
    clientSurveys: 'Ankiety dla klientów bez wyników',
    preparedDate: 'Data przygotowania',
    sentDate: 'Data wysłania',
    answeredDate: 'Data odpowiedzi',
    repetition: 'Numer przypomnienia',
    noClientSurveys: 'Brak ankiet dla klientów w systemie',
    waitingToSend: 'Oczekujące na wysłanie',
    waitingForAnswer: 'Oczekujące na odpowiedź',
    all: 'Wszystkie',
    expiredWithoutReminder: 'Przeterminowane bez przypomnienia',
    repeat: 'Ponów',
    repeatConfirmation:
      'Czy jesteś pewien, że chcesz ponownie przygotować ankietę do kontrahenta?',
    repeatSuccess: 'Ankieta do kontrahenta została przygotowana.',
    repeatError: 'Nie udało się utworzyć ponownie ankiety do kontrahenta.',
    withAnswered: 'Wyniki ankiet',
    nextStartGenerateClientSurvey:
      'Następne uruchomienie przygotowywania ankiet dla klientów',
    nextStartSendToClientSurvey:
      'Następne uruchomienie wysyłania ankiet do klientów',
    frequency: 'Częstotliwość',
    warning: 'Uwagi',
    withRemarks: 'Wyniki z uwagami',
    surveyResultsReport: 'Zestawienie wyników',
    surveyResultsWithRemarksReport: 'Zestawienie wyników z uwagami',
  },
  publicSurvey: {
    invalidLink: 'Nieprawidłowy link do ankiety',
    notFoundOrInactive: 'Ankieta nie została znaleziona lub jest nieaktywna',
    saveError: 'Wystąpił błąd podczas zapisywania odpowiedzi',
    requiredField: 'Proszę udzielić odpowiedzi na to pytanie',
    blockedAnswer: 'Ta odpowiedź nie pozwala na kontynuację ankiety',
    surveyFor: 'Ankieta dla: ',
    estimatedTime: 'Szacowany czas wypełnienia',
    startSurvey: 'Rozpocznij ankietę',
    numberOfQuestions: 'Liczba pytań',
    thankYou: 'Dziękujemy!',
    answersSaved:
      'Twoje odpowiedzi zostały zapisane. Dziękujemy za poświęcony czas i udział w ankiecie.',
    surveyCompletedBy: 'Ankieta wypełniona przez',
    yes: 'Tak',
    no: 'Nie',
    back: 'Wstecz',
    next: 'Dalej',
    finish: 'Zakończ ankietę',
    finishSurvey: 'Zakończ ankietę',
    question: 'Pytanie {{current}} z {{total}}',
    commentOptional: 'Komentarz (opcjonalnie)',
    addComment: 'Dodaj swój komentarz...',
    errorTitle: 'Błąd',
    enterYourAnswer: 'Wpisz swoją odpowiedź',
    submitError:
      'Wystąpił błąd podczas przesyłania ankiety. Proszę spróbować ponownie.',
  },
} as const;
